import * as complaintPositionTypes from '../types/ComplaintPosition';
import * as pageActions from './Page';

export function updateField(name,value) {
    return {
        type: complaintPositionTypes.COMPLAINT_POSITION_UPDATE_FIELD,
        payload: { [name] : value}
    };
}

export function ChangeAmount(amount) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_AMOUNT,
        payload: {amount: amount}
    };
}

export function ChangeArticleSerialNumber(articleSerialNumber) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_ARTICLE_SERIAL_NUMBER,
        payload: {articleSerialNumber: articleSerialNumber}
    };
}

export function ChangeArticlePurchaseDate(articlePurchaseDate) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_ARTICLE_PURCHASE_DATE,
        payload: {articlePurchaseDate: articlePurchaseDate}
    };
}

export function ChangeCustomerRequest(customerRequest) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_CUSTOMER_REQUEST,
        payload: {customerRequest: customerRequest}
    };
}

export function ChangeFaultDate(faultDate) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_FAULT_DATE,
        payload: {faultDate: faultDate}
    };
}

export function ChangeFaultDescription(faultDescription) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_FAULT_DESCRIPTION,
        payload: {faultDescription: faultDescription }
    };
}

export function ChangeFaultDiscoveryCircumstances(faultDiscoveryCircumstances) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_FAULT_DISCOVERY_CIRCUMSTANCES,
        payload: {faultDiscoveryCircumstances: faultDiscoveryCircumstances }
    };
}

export function ChangeInvoiceQuantity(invoiceQuantity) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_INVOICE_QUANTITY,
        payload: {invoiceQuantity: invoiceQuantity }
    };
}

export function ChangeProduct(product) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_PRODUCT,
        payload: {product: product}
    };
}

export function ChangeQuantityCorrectionsProposal(quantityCorrectionsProposal) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_QUANTITY_CORRECTIONS_PROPOSAL,
        payload: {quantityCorrectionsProposal: quantityCorrectionsProposal}
    };
}

export function ChangeSalesDocumentNumber(salesDocumentNumber) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_NUMBER,
        payload: {salesDocumentNumber: salesDocumentNumber}
    };
}

export function ChangeShipmentDescription(shipmentDescription) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_SHIPMENT_DESCRIPTION,
        payload: {shipmentDescription: shipmentDescription}
    };
}

export function ChangeNotes(notes) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_NOTES,
        payload: {notes: notes}
    };
}

export function ChangeCourier(courier) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_COURIER,
        payload: {courier: courier}
    };
}

export function ChangeDateOfReceiptOfGoods(dateOfReceiptOfGoods){
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_DATE_OF_RECEIPT_OF_GOODS,
        payload: {dateOfReceiptOfGoods: dateOfReceiptOfGoods}
    };
}

export function ChangeSalesDocumentPosition(salesDocumentPosition){
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_POSITION,
        payload: {salesDocumentPosition: salesDocumentPosition}
    };
}


export function ChangeShippedQuantity(shippedQuantity) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_SHIPPED_QUANTITY,
        payload: {shippedQuantity: shippedQuantity}
    };
}

export function ChangeTermOfUse(termOfUse) {
    return{
        type: complaintPositionTypes.COMPLAINT_POSITION_CHANGE_TERM_OF_USE,
        payload: {termOfUse: termOfUse}
    };
}

export function addPurchaseAddressToPosition() {
    return (dispatch, getState) => {
        const company = getState().company.selectedRow;
        dispatch(addPurchaseAddressToComplaintPosition({
            companyName:company.companyName
        }));
      };
}

function addPurchaseAddressToComplaintPosition(company) {
    return {
        type: complaintPositionTypes.ADD_PURCHASE_ADDRESS_TO_COMPLAINT_POSITION,
        payload: company
    };
}

export function AddFile(file,filesTargetName) {
    return {
        type: complaintPositionTypes.COMPLAINT_POSITION_ADD_FILE,
        fileToAdd: file,
        filesTargetName
    };
}

export function RemoveFile(file) {
    return {
        type: complaintPositionTypes.COMPLAINT_POSITION_REMOVE_FILE,
        fileToRemove: file
    };
}

export function DismissChanges() {
    return (dispatch) => {
        dispatch({ type: complaintPositionTypes.COMPLAINT_POSITION_DISSMIS_CHANGES});
        dispatch(pageActions.changePageToCreateComplaintPositions());
    };
}

export function fillComplaintPositionByObject(complaintPosition) {
    return {
        type: complaintPositionTypes.COMPLAINT_POSITION_FILL_BY_OBJECT,
        position: complaintPosition
    };
}






// WEBPACK FOOTER //
// ./src/actions/ComplaintPosition.js